"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Sets the global path to the API endpoint. Can be overridden in the individual client contructors. */
exports.API_BASE_PATH = 'http://127.0.0.1:8080/fleet/v2';
//# sourceMappingURL=variables.js.map